import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep } from 'lodash-es'
import InputForm from '../../../components/forms/input/InputForm'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function ActivitieSettingTimeWidget({
  schema: _schema,
  items,
  header,
  refId,
  resultName = 'activityTimeName',
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [inputList, setInputList] = useState([])
  const [schema, setSchema] = useState(_schema)
  const [inputIndex, setInputIndex] = useState(1)

  useEffect(() => {
    setSchema(_schema)
  }, [_schema])

  useEffect(() => {
    setInputList(items)

    setValue(resultName, items)
  }, [items])

  const onAddSetting = () => {
    // let newId = 'NEW_' + datas.length
    let inputs = cloneDeep(inputList || [])
    let newId = 'NEW_' + refId + ':' + inputIndex
    let input = {
      id: newId,
      refId: refId,
      value: '',
    }
    inputs.push(input)

    setInputIndex(inputIndex + 1)
    setInputList(inputs)

    setValue(resultName, inputs)
  }

  const onDelSetting = (index) => {
    let inputs = cloneDeep(inputList || [])
    if (index > -1) {
      inputs.splice(index, 1)
    }
    setInputList(inputs)
    setValue(resultName, inputs)
  }

  return (
    <Panel
      style={props.style || { marginTop: 20 }}
      header={header || 'ช่วงเวลาที่จัดกิจกรรม'}
      collapsible
      defaultExpanded
      bordered
    >
      <div style={{ marginTop: -10 }}>
        <Controller key={resultName} name={resultName} control={control} defaultValue={inputList} />

        {inputList?.map((data, index) => {
          return (
            <>
              <Row>
                <Col xs={24} sm={20} md={22} lg={22}>
                  <InputForm
                    schema={schema.activityTimeName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    name={`${schema.activityTimeName.name}:${data.id}`}
                    value={data.value}
                    onChange={(value) => {
                      let inputs = cloneDeep(inputList)
                      inputs[index].value = value

                      setInputList(inputs)
                      setValue(resultName, inputs)
                    }}
                  />
                </Col>
                <Col xs={24} sm={4} md={2} lg={2}>
                  <CancelButton
                    style={{ marginTop: 35 }}
                    icon="trash-o"
                    children="ลบ"
                    onClick={() => {
                      onDelSetting(index)
                    }}
                  />
                </Col>
              </Row>
            </>
          )
        })}
        <SaveButton style={{ marginTop: 20 }} icon="plus" children="เพิ่ม" onClick={onAddSetting} />
      </div>
    </Panel>
  )
}
